export default __webpack_public_path__ + "static/media/background.c68e9ed9.jpg";